export default __webpack_public_path__ + "facebook-start.22b450911f76c77db6542808f04e8694.png";